<template>
    <div>
        <div class="top-toolbox">
            <button class="chatbot-btn" :class="{ selected: bar === 1 }" @click="toggleBar(1)" :disabled="previewMode">
                <md-icon>bolt</md-icon>
            </button>
            <button class="chatbot-btn" :class="{ selected: bar === 6 }" @click="toggleBar(6)">
                <md-icon>electrical_services</md-icon>
            </button>
            <button class="chatbot-btn" :class="{ selected: bar === 2 }" @click="toggleBar(2)" :disabled="previewMode">
                <md-icon>search</md-icon>
            </button>
            <button class="chatbot-btn" :class="{ selected: bar === 3 }" @click="toggleBar(3)" :disabled="previewMode">
                <md-icon>settings</md-icon>
            </button>
            <button class="chatbot-btn" :class="{ selected: bar === 4 }" @click="toggleBar(4)">
                <md-icon>history</md-icon>
            </button>
            <a-button type="primary" ghost @click="toggleBar(5)">
                {{ $t("chatbotv2.testBot") }}
            </a-button>
            <a-button
                type="primary"
                @click="versionModal = true"
                :disabled="previewMode"
                v-if="checkPermission(PERMISSION_TYPES['chatbot.stories.update'].tr.name)"
            >
                <span class="d-flex justify-content-between align-content-center align-items-center">
                    <span class="material-icons" style="">send</span>
                    <b class="ml-2">{{ $t("chatbotv2.publish") }}</b>
                </span>
            </a-button>
        </div>

        <div class="side-bar" v-if="bar !== 0">
            <ActionPalette
                v-if="bar === 1"
                :dragMode="dragMode"
                :dragStart="dragStart"
                :dragEnd="dragEnd"
                :addBlockToDiagram="addBlockToDiagram"
                :bar="bar"
                @close-menu="bar = $event"
            />
            <SearchWidget
                :blocksMetas="blocksMetas"
                @focusBlock="focusBlock"
                v-if="!previewMode && bar === 2"
                :flattedDiagram="flattedDiagram"
                :toggleBar="toggleBar"
                :bar="bar"
                @close-menu="bar = $event"
                :board="board"
                :navigateTo="navigateTo"
            />
            <SettingsWidget
                @close-menu="bar = $event"
                v-if="!previewMode && bar === 3"
                :bar="bar"
                :diagram="diagram"
                :story-id="storyId"
                :board="board"
            />
            <VersionSwitcher :story-id="storyId" v-if="bar === 4" :bar="bar" @close-menu="bar = $event" />
            <ChatWidget
                v-if="bar === 5"
                @close-menu="bar = $event"
                :story-id="storyId"
                :version="version"
                :test-start-block-id="testStartBlockId"
                :diagram="diagram"
            />
            <AddIntergation
                v-if="bar === 6"
                :storyId="storyId"
                @close-menu="bar = $event"
            />
        </div>
        <a-modal
            id="publish-modal"
            :title="$t('chatbotv2.newVersion')"
            wrapClassName="vertical-center-modal"
            v-model="versionModal"
            @ok="publishHandler"
            @cancel="versionModal = false"
            :okText="$t('message.ok')"
            :cancelText="$t('message.cancel')"
        >
            <a-form class="d-flex flex-column justify-content-center" @submit.prevent="publishHandler">
                <a-input :value="$route.params.version" placeholder="1.0" disabled="disabled" />
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import ActionPalette from "../../toolbar/ActionPalette";
import SearchWidget from "../../toolbar/SearchWidget";
import SettingsWidget from "../../toolbar/SettingsWidget";
import VersionSwitcher from "../../toolbar/VersionSwitcher";
import ChatWidget from "../../preview/ChatWidget";
import { log2 } from "../../../../../../../utils/log2";
import SYSTEM_PUBSUB from "../../../../../../../utils/systemPubSub";
import { mapActions, mapGetters, mapState } from "vuex";
import { PERMISSION_TYPES } from "../../../../../../../language/permissionTypes";
import AddIntergation from "../../toolbar/AddIntergation.vue";

const log = log2("Toolbar");

export default {
    name: "Toolbar",
    props: [
        "dragMode",
        "dragStart",
        "dragEnd",
        "addBlockToDiagram",
        "flattedDiagram",
        "blocksMetas",
        "storyId",
        "version",
        "testStartBlockId",
        "diagram",
        "defaultOpenBarIndex",
        "board",
        "previewMode",
        "navigateTo",
    ],
    components: {
        VersionSwitcher,
        SettingsWidget,
        SearchWidget,
        ActionPalette,
        ChatWidget,
        AddIntergation,
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    data() {
        return {
            bar: this.previewMode ? 4 : 1,
            versionModal: false,
        };
    },
    methods: {
        ...mapActions({
            publishBoard: "CB/publishBoard",
            makeDefaultStory: "CB/makeDefaultStory",
        }),
        toggleBar(index) {
            if (this.bar !== index) this.bar = index;
            else this.bar = 0;
        },
        focusBlock(block) {
            if (["START_POINT", "DEFAULT_FALLBACK"].includes(block.type)) return;
            if (block.type === "FLOW") {
                this.navigateToBlock(block);
                return;
            }
            this.$emit("openModal", block);
            let target = this.blocksMetas[`${block.id}`];
            let parentNode = this.blocksMetas[`${block.parent.id}`];
            log("focusBlock parentNode", parentNode.x, parentNode.y);
            log("focusBlock target", target.x, target.y);
            log("focusBlock block", block);
            parentNode.center = {
                x: parentNode.width / 4 - parentNode.x / 2,
                y: parentNode.height / 2 + parentNode.y / 2,
            };
            target.center = {
                x: target.x - parentNode.x + target.width / 2,
                y: target.y - parentNode.y + target.height / 2,
            };
            // log("focusBlock", target.center, parentNode.center);
            this.$emit("setTranslate", {
                diffX: parentNode.center.x - target.center.x,
                diffY: parentNode.center.y - target.center.y,
            });
        },
        publishHandler() {
            this.publishBoard({
                id: this.storyId,
                version: this.version,
                publishVersion: this.$route.params.version,
            });
            this.versionModal = false;

            const isThereAnyDefaultStory = (this.stories || []).some((story) =>
                _.get(story, "integrations.supsisWidget")
            );
            if (!isThereAnyDefaultStory) {
                const self = this;
                this.$confirm({
                    title: this.$t("chatbotv2.noDefaultStoryTitle"),
                    content: this.$t("chatbotv2.noDefaultStory"),
                    okText: this.$t("chatbotv2.yes"),
                    cancelText: this.$t("chatbotv2.no"),
                    width: 600,
                    height: 600,
                    async onOk() {
                        self.makeDefaultStory({ selectedStory: self.storyId, integrationApp: "supsisWidget" });
                    },
                    onCancel() {},
                });
            }
        },
    },
    watch: {
        testStartBlockId(val) {
            if (val) {
                this.bar = 5;
            } else {
                if (this.bar === 5) this.bar = null;
            }
        },
        bar(val, oldVal) {
            if (val === 5) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_CHAT_WIDGET_OPEN_STATE_CHANGED, {
                    visible: true,
                });
            }
            if (oldVal === 5) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_CHAT_WIDGET_OPEN_STATE_CHANGED, {
                    visible: false,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.top-toolbox {
    position: absolute;
    top: 1.7rem;
    right: 2rem;
    z-index: 999;
    display: flex;
    gap: 6px;
    background: #fff;
    padding: 3px 6px;
    border-radius: 8px;
    box-shadow: 0px 4px 20px #00000040;
    height: 50px;
    width: 440px;
    align-items: center;
}

.side-bar {
    position: absolute;
    top: 7rem;
    right: 2rem;
    z-index: 999;
    border-radius: 8px;
}

.chatbot-btn {
    border: none;
    background: #fff;
    border-radius: 4px;
    padding: 4px 8px;
    margin: 0;
    min-height: 34px;
    min-width: 34px;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;

    &.bordered {
        border: 1px solid #000;
    }

    &.selected {
        .md-icon {
            color: #006cff !important;
        }
    }
}
</style>
